import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner.tsx";
import { AuthProvider } from "@/components/auth/AuthProvider.tsx";
import { UserAuthProvider } from "@/components/auth/UserAuthProvider.tsx";
import { Landing } from "@/pages/Landing.tsx";
import { StoryEditor } from "@/pages/StoryEditor.tsx";
import { AuthCallback } from "@/pages/AuthCallback.tsx";
import { NotFound } from "@/pages/NotFound.tsx";
import { Login } from "@/pages/Login.tsx";
import { UserAuthCallback } from "@/pages/UserAuthCallback.tsx";
import { PublicCatalogue } from "@/pages/PublicCatalogue.tsx";
import { PublicStory } from "@/pages/PublicStory.tsx";
import "./lib/i18n/config.ts";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
      <UserAuthProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/story/:id" element={<StoryEditor />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/auth/user/callback" element={<UserAuthCallback />} />
              <Route path="/catalog" element={<PublicCatalogue />} />
              <Route path="/catalog/:slug" element={<PublicStory />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </AuthProvider>
      </UserAuthProvider>
    </ThemeProvider>
  );
}

export default App;
